/**
 * @generated SignedSource<<1f65f666f6fa76757fb464229525144d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type displayAcquisitionPopupContainerQuery$variables = Record<PropertyKey, never>;
export type displayAcquisitionPopupContainerQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"hooksUseAcquisitionPopupQuery">;
};
export type displayAcquisitionPopupContainerQuery = {
  response: displayAcquisitionPopupContainerQuery$data;
  variables: displayAcquisitionPopupContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "json",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "displayAcquisitionPopupContainerQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "hooksUseAcquisitionPopupQuery"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "displayAcquisitionPopupContainerQuery",
    "selections": [
      {
        "alias": "pptoConfig",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "scmp_pwa_ppto"
            }
          }
        ],
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": (v0/*: any*/),
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_ppto\"})"
      },
      {
        "alias": "settings",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "scmp_pwa_settings"
            }
          }
        ],
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": (v0/*: any*/),
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_settings\"})"
      }
    ]
  },
  "params": {
    "cacheID": "7baacf5c66135b8e20ec68cb94e5e709",
    "id": null,
    "metadata": {},
    "name": "displayAcquisitionPopupContainerQuery",
    "operationKind": "query",
    "text": "query displayAcquisitionPopupContainerQuery {\n  ...hooksUseAcquisitionPopupQuery\n}\n\nfragment hooksUseAcquisitionPopupQuery on Query {\n  pptoConfig: appConfig(filter: {entityId: \"scmp_pwa_ppto\"}) {\n    json\n    id\n  }\n  settings: appConfig(filter: {entityId: \"scmp_pwa_settings\"}) {\n    json\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ff4df315a1765e4d99b01b77df32294";

export default node;
